import {OnInit, Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {ArmaServServerMethods} from '../../../classes/ArmaServServerMethods';
import {MatTableDataSource} from '@angular/material/table';
import {ArmaRestContact} from '../../../classes/json-interface';
import {DialogContactComponent} from '../dialogContact/dialog-contact.component';

interface DialogData {
  readonly siteCode: string;
}

const CST_MAT_TABLE_COL_NAME = 'CST_MAT_TABLE_COL_NAME';
const CST_MAT_TABLE_COL_LAST_NAME = 'CST_MAT_TABLE_COL_LAST_NAME';
const CST_MAT_TABLE_COL_PHONE = 'CST_MAT_TABLE_COL_PHONE';
const CST_MAT_TABLE_COL_EMAIL = 'CST_MAT_TABLE_COL_EMAIL';
const CST_MAT_TABLE_COL_ACTION = 'CST_MAT_TABLE_COL_ACTION';

@Component({
  templateUrl: './dialog-list-contact-component.html',
  styleUrls: ['dialog-list-contact-component.css']
})
export class DialogListContactComponent implements OnInit {

  public static async openDialog(dialog: MatDialog, siteCode: string): Promise<undefined|ArmaRestContact> {
    const dialogData: DialogData = { siteCode: siteCode };
    const matDialogRef = dialog.open(DialogListContactComponent, { data: dialogData, minWidth: '75%' });
    return matDialogRef.afterClosed().toPromise();
  }

  public readonly CST_MAT_TABLE_COL_NAME = CST_MAT_TABLE_COL_NAME;
  public readonly CST_MAT_TABLE_COL_LAST_NAME = CST_MAT_TABLE_COL_LAST_NAME;
  public readonly CST_MAT_TABLE_COL_PHONE = CST_MAT_TABLE_COL_PHONE;
  public readonly CST_MAT_TABLE_COL_EMAIL = CST_MAT_TABLE_COL_EMAIL;
  public readonly CST_MAT_TABLE_COL_ACTION = CST_MAT_TABLE_COL_ACTION;

  public matTableDisplayedColumns = [CST_MAT_TABLE_COL_NAME, CST_MAT_TABLE_COL_LAST_NAME,
    CST_MAT_TABLE_COL_PHONE, CST_MAT_TABLE_COL_EMAIL, CST_MAT_TABLE_COL_ACTION];
  public matTableDataSource: MatTableDataSource<ArmaRestContact> = new MatTableDataSource<ArmaRestContact>([]);

  public loadingData: boolean = false;

  constructor(public mDialogRef: MatDialogRef<DialogListContactComponent>,
              @Inject(MAT_DIALOG_DATA) public dialogData: DialogData,
              private mArmaServMethod: ArmaServServerMethods,
              private mDialog: MatDialog) {

  }

  ngOnInit() {
    this.loadListContact().catch(console.error);
  }

  private async loadListContact() {
    this.loadingData = true;
    try {
      this.matTableDataSource.data = await this.mArmaServMethod.getListContact(this.dialogData.siteCode);
    } finally {
      this.loadingData = false;
    }
  }

  public asContact(contact: ArmaRestContact): ArmaRestContact {
    return contact;
  }

  public onBtnItemClick(contact: ArmaRestContact, bEdit: boolean) {
    if (bEdit) {
      this.updateContact(contact).then(this.loadListContact.bind(this));
    } else {
      this.mDialogRef.close(contact);
    }
  }

  public onBtnDialogClick(btnType: 'addNew'|'close') {
    switch (btnType) {
      case 'addNew':
        this.createContact().then(this.loadListContact.bind(this));
        break;
      case 'close':
        this.mDialogRef.close();
        break;
    }
  }

  private async createContact() {
    const newContactInfo = await DialogContactComponent.openDialog(this.mDialog);
    if (!newContactInfo)
      return;
    const createdContact = await this.mArmaServMethod.createContact(this.dialogData.siteCode, newContactInfo);
    console.log('createdContact', createdContact);
  }

  private async updateContact(contact: ArmaRestContact) {
    const newContactInfo = await DialogContactComponent.openDialog(this.mDialog, contact);
    if (!newContactInfo)
      return;
    const updatedContact = await this.mArmaServMethod.updateContact(contact.Id, newContactInfo);
    console.log('updatedContact', updatedContact);
  }
}
